// extracted by mini-css-extract-plugin
export default {"breadcrumb":"BreadCrum_breadcrumb__hlHXi","separator":"BreadCrum_separator__aUxAc","active":"BreadCrum_active__5Fxcb"};